export const lexofficeConstants = {
    GET_STRIPE_LEX_OFFICE_CONFIGURATION_REQUEST: "GET_STRIPE_LEX_OFFICE_CONFIGURATION_REQUEST",
    GET_STRIPE_LEX_OFFICE_CONFIGURATION_SUCCESS: "GET_STRIPE_LEX_OFFICE_CONFIGURATION_SUCCESS",
    GET_STRIPE_LEX_OFFICE_CONFIGURATION_FAILURE: "GET_STRIPE_LEX_OFFICE_CONFIGURATION_FAILURE",

    UPDATE_STRIPE_LEX_OFFICE_CONFIGURATION_REQUEST: "UPDATE_STRIPE_LEX_OFFICE_CONFIGURATION_REQUEST",
    UPDATE_STRIPE_LEX_OFFICE_CONFIGURATION_SUCCESS: "UPDATE_STRIPE_LEX_OFFICE_CONFIGURATION_SUCCESS",
    UPDATE_STRIPE_LEX_OFFICE_CONFIGURATION_FAILURE: "UPDATE_STRIPE_LEX_OFFICE_CONFIGURATION_FAILURE",

    DELETE_STRIPE_LEX_OFFICE_CONFIGURATION_REQUEST: "DELETE_STRIPE_LEX_OFFICE_CONFIGURATION_REQUEST",
    DELETE_STRIPE_LEX_OFFICE_CONFIGURATION_SUCCESS: "DELETE_STRIPE_LEX_OFFICE_CONFIGURATION_SUCCESS",
    DELETE_STRIPE_LEX_OFFICE_CONFIGURATION_FAILURE: "DELETE_STRIPE_LEX_OFFICE_CONFIGURATION_FAILURE",

    TOGGLE_EDIT_STRIPE_LEX_OFFICE_CONFIGURATION_MODAL: "TOGGLE_EDIT_STRIPE_LEX_OFFICE_CONFIGURATION_MODAL",
    TOGGLE_DELETE_STRIPE_LEX_OFFICE_CONFIGURATION_MODAL: "TOGGLE_DELETE_STRIPE_LEX_OFFICE_CONFIGURATION_MODAL",

    GET_LEX_OFFICE_CONNECTION_STATUS_REQUEST: "GET_LEX_OFFICE_CONNECTION_STATUS_REQUEST",
    GET_LEX_OFFICE_CONNECTION_STATUS_SUCCESS: "GET_LEX_OFFICE_CONNECTION_STATUS_SUCCESS",
    GET_LEX_OFFICE_CONNECTION_STATUS_FAILURE: "GET_LEX_OFFICE_CONNECTION_STATUS_FAILURE",

    GET_LEX_OFFICE_LOG_REQUEST: "GET_LEX_OFFICE_LOG_REQUEST",
    GET_LEX_OFFICE_LOG_SUCCESS: "GET_LEX_OFFICE_LOG_SUCCESS",
    GET_LEX_OFFICE_LOG_FAILURE: "GET_LEX_OFFICE_LOG_FAILURE",

    REFRESH_LEX_OFFICE_TOKEN_REQUEST: "REFRESH_LEX_OFFICE_TOKEN_REQUEST",
    REFRESH_LEX_OFFICE_TOKEN_SUCCESS: "REFRESH_LEX_OFFICE_TOKEN_SUCCESS",
    REFRESH_LEX_OFFICE_TOKEN_FAILURE: "REFRESH_LEX_OFFICE_TOKEN_FAILURE",

    REGISTER_LEX_OFFICE_ORGANIZATION_REQUEST: "REGISTER_LEX_OFFICE_ORGANIZATION_REQUEST",
    REGISTER_LEX_OFFICE_ORGANIZATION_SUCCESS: "REGISTER_LEX_OFFICE_ORGANIZATION_SUCCESS",
    REGISTER_LEX_OFFICE_ORGANIZATION_FAILURE: "REGISTER_LEX_OFFICE_ORGANIZATION_FAILURE",
};
